import { Button, Card, FileDrop, Icon, Input, Modal, Notification, Select, Tab, Loader, TextArea } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import { LabelDescription } from 'components';
import Alert from 'components/alert';
import useFetch from 'helpers/hooks/useFetch';
import useUser from 'helpers/hooks/useUser';
import { NewEquipmentMf } from 'models/rmamanufatura/newEquipmentModel';
import { NewManufacturingMf } from 'models/rmamanufatura/newManufacturingModel';
import {
    RmaItemsMf,
    rmaItemsAccessoriesModelMf,
    rmaItemsEquipmentModelMf,
    rmaCartManufacturingModelMf
} from 'models/rmamanufatura/detailsRma';
import { useEffect, useState, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { CreatNewRmaMf, REPAIR_CENTER, RMAMANUFATURA, LOB } from 'resources';
import { itemCartDelete } from 'resources/api/';
import { volOptionMf, timeMf } from 'models/rmamanufatura/types';
import ImagesManufacturing from './ImagesManufacturing';
import { uploadRmaExcel } from 'resources/api/rmaManufatura_api/newRmaManufatura';
import { downloadPublicFile } from 'resources/api/general_api/PublicFiles';
import { useSetRecoilState } from 'recoil';
import { notificationAtom } from 'resources';
import React from 'react';

interface SelectOption {
    value: string;
    text: string;
    lob: string;
}

function NewRma() {
    const PROBLEMA_OUTRO = 56;
    const { t } = useTranslation(['rmamanufatura', 'common', 'user']);
    const [loadingDel, setLoadingDel] = useState<boolean>(false);
    const [loadPns, setLoadPns] = useState(false);
    const [newEquipment, setNewEquipment] = useState<NewEquipmentMf>(new NewEquipmentMf());
    const [newManufacturing, setNewManufacturing] = useState<NewManufacturingMf>(new NewManufacturingMf());
    const [details, setDetails] = useState<any>([]);
    const [problemTypes, setProblemTypes] = useState<[]>([]);
    const [tab, setTab] = useState<number>(0);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [deletedItem, setDeletedItem] = useState<any>([]);
    const [arquivoXLSX, setArquivoXLSX] = useState<File | undefined>();
    const [data, setData] = useState<any[]>([]);
    const [rmaState, setRmaState] = useRecoilState(CreatNewRmaMf);
    const [uploadXLSX, setUploadXLSX] = useState<boolean>(false);
    const [uploadXLSXResult, setUploadXLSXResult] = useState<string>('');
    const [uploadXLSXSuccess, setUploadXLSXSuccess] = useState<boolean>(true);
    const [fullLoading, setFullLoading] = useState<string>('');
    const [rmaCartIds, setRmaCartIds] = useState<number[]>([]);
    const [submit, setSubmit] = useState(false);
    const [lob, setLob] = useState<string>('');
    const [opcoesSelect, setOpcoesSelect] = useState<SelectOption[]>([]);
    const { user } = useUser();
    const navigate = useNavigate();
    const setNotification = useSetRecoilState(notificationAtom);
    const searchDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const searchRequestIdRef = useRef(0);

    const [addItemInCartManufacturing, addItemCartManufacturing, loading] = useFetch<NewEquipmentMf, NewManufacturingMf>({
        url: RMAMANUFATURA.addItemInCartManufacturing,
        method: 'POST',
        onError: 'MessageNumSerie'
    });

    const [, getItemsInCartManufacturing] = useFetch<{ ssoId: string }>({
        url: RMAMANUFATURA.getItemsInCartManufacturing,
        method: 'GET'
    });

    const [problemLocationsAndTypes, getProblemLocationsAndTypes] = useFetch<{ page: string }, any[]>({
        url: REPAIR_CENTER.getProblemLocationsAndTypes
    });

    const [, getServiceTypes] = useFetch({ url: REPAIR_CENTER.getServiceTypes });

    const [listPns, getAllPns, loadPartNumbers] = useFetch<{ code: string }>({
        url: RMAMANUFATURA.getAllPns
    })

    const [gbe, getGBE] = useFetch<{ lob: string }>({
        url: LOB.getGBEs,
        method: 'GET'
    })

    useEffect(() => {
        findItemInCart();
        changeTab(tab);
        getServiceTypes();
        getProblemLocationsAndTypes({ page: 'manufacturing' }, (curr: any) => {
            setProblemTypes(curr?.data?.map((e: any) => e.problemTypes));
        });
    }, []);

    useEffect(() => {
        if (listPns?.data) {
            const options = listPns.data
                .filter((item: any) => item?.partNumber && item?.lob)
                .map((item: any) => ({
                    value: item.partNumber,
                    text: item.partNumber,
                    lob: item.lob,
                }));
            setOpcoesSelect(options);
        }
    }, [listPns])

    useEffect(() => {
        if (user?.ssoid) {
            setNewEquipment(prev => ({ ...prev, ssoId: user.ssoid }));
            setNewManufacturing(prev => ({ ...prev, ssoId: user.ssoid }));
        }
    }, [user]);

    useEffect(() => {
        if (details.length > 0 && rmaState?.rmaItems && rmaState?.rmaItems?.length > 0) {
            const firstDetailId = details[0]?.Id;
            const correspondingItem = rmaState.rmaItems.find(item => item.id === firstDetailId);

            if (correspondingItem) {
                setNewManufacturing(prev => ({
                    ...prev,
                    rmaCartManufacturing: {
                        ...prev.rmaCartManufacturing,
                        nfHoneywell: correspondingItem.rmaCartManufacturing?.nfHoneywell || prev.rmaCartManufacturing?.nfHoneywell,
                        identifiedTime: correspondingItem.rmaCartManufacturing?.identifiedTime || prev.rmaCartManufacturing?.identifiedTime,
                        volumeType: prev.rmaCartManufacturing?.volumeType,
                        gbe: correspondingItem.rmaCartManufacturing?.gbe || prev.rmaCartManufacturing?.gbe
                    }
                }));

                setNewEquipment(prev => ({
                    ...prev,
                    rmaItemsEquipment: {
                        ...prev.rmaItemsEquipment,
                        problemLocationId: correspondingItem.rmaItemsEquipment?.problemLocationId || prev.rmaItemsEquipment?.problemLocationId,
                        problemTypeDescription: correspondingItem.rmaItemsEquipment?.problemTypeDescription || prev.rmaItemsEquipment?.problemTypeDescription
                    }
                }));
            }
        }
    }, [details.length, rmaState?.rmaItems?.length]);

    const buildSelect = (list: any[] | undefined) => {
        if (!list) return [];
        let listResult = [];
        for (let i in list) {
            let d: any = { value: list[i].id, text: list[i].name, problemTypes: list[i].problemTypes };
            listResult.push(d);
        }
        return listResult;
    };

    const nextPage = async () => {
        setSubmit(true);
        navigate('summaryManufacturing');
    };

    const getGbe = async () => {
        if (lob) {
            await getGBE({ lob: lob })
        }
    };

    useEffect(() => {
        if (lob) {
            getGbe();
        }
    }, [lob]);

    useEffect(() => {
        if (gbe?.data) {

            if (rmaState?.rmaItems && rmaState?.rmaItems?.length > 0) {
                if (rmaState.rmaItems[0].rmaCartManufacturing.gbe != gbe?.data) {
                    setNotification(old => ({ ...old, message: t('rmamanufatura:translation.ErrorGBE') }));
                    setNewEquipment({ ...newEquipment, model: '', ssoId: user?.ssoid });
                    setLob('');

                    return
                }
            }
            setNewManufacturing((prev) => ({
                ...prev,
                rmaCartManufacturing: {
                    ...prev.rmaCartManufacturing,
                    gbe: gbe.data
                }
            }));
        }
    }, [gbe]);

    useEffect(() => {
        if (newManufacturing.rmaCartManufacturing?.volumeType === 4) {
            setNewManufacturing(prev => ({
                ...prev,
                rmaCartManufacturing: {
                    ...prev.rmaCartManufacturing,
                    quantity: '1'
                }
            }));
        } else {
            setNewManufacturing(prev => ({
                ...prev,
                rmaCartManufacturing: {
                    ...prev.rmaCartManufacturing,
                    quantity: ''
                }
            }));
        }
    }, [newManufacturing.rmaCartManufacturing?.volumeType]);

    const fetchFilteredPns = useCallback(
        async (pn: string) => {
            const texto = pn?.trim() ?? "";

            if (texto.length === 0) {
                setOpcoesSelect([]);
                return;
            }

            // Gera um id para essa busca
            const myRequestId = ++searchRequestIdRef.current;

            try {
                setLoadPns(true);
                await getAllPns({ code: texto });

                // Só aplica o resultado se este request ainda for o mais recente:
                if (myRequestId !== searchRequestIdRef.current) return;

                const fonte = listPns?.data ?? [];

                const options = fonte
                    .filter((item: any) => item?.partNumber && item?.lob)
                    .map((item: any) => ({
                        value: item.partNumber,
                        text: item.partNumber,
                        lob: item.lob,
                    }));

                setOpcoesSelect(options);
            } catch (e) {

            } finally {
                if (myRequestId === searchRequestIdRef.current) {
                    setLoadPns(false);
                }
            }
        },
        [getAllPns, listPns?.data]
    );

    const addEquipment = () => {
        const updatedEquipment = {
            ...newEquipment,
            ssoId: user?.ssoid
        };

        const updatedManufacturing = {
            ...newManufacturing,
            ssoId: user?.ssoid
        };
        sendAddItemCart(updatedEquipment, updatedManufacturing);
    };

    const sendAddItemCart = async (updatedEquipment: NewEquipmentMf, updatedManufacturing: NewManufacturingMf) => {
        setNewEquipment(current => {
            if (current && tab === 1) {
                const { rmaItemsAccessories, ...rest } = updatedEquipment;
                return rest;
            } else {
                const { rmaItemsEquipment, ...rest } = updatedEquipment;
                return rest;
            }
        });

        setNewManufacturing(() => {
            return {
                ...updatedManufacturing,
                rmaCartManufacturing: updatedManufacturing.rmaCartManufacturing
            };
        });

        const serialNumber =
            newManufacturing.rmaCartManufacturing?.volumeType === 1 ? '-' : updatedEquipment.rmaItemsEquipment?.serialNumber;
        const problemTypeDescription =
            newEquipment.rmaItemsEquipment?.problemLocationId !== PROBLEMA_OUTRO
                ? '-'
                : updatedEquipment.rmaItemsEquipment?.problemTypeDescription;

        const payload = {
            serviceTypeId: newEquipment.serviceTypeId,
            ssoId: newEquipment.ssoId,
            model: newEquipment.model,
            rmaCartManufacturing: newManufacturing.rmaCartManufacturing,
            rmaItemsEquipment: {
                ...updatedEquipment.rmaItemsEquipment,
                serialNumber: serialNumber,
                problemTypeDescription: problemTypeDescription
            }
        };
        await addItemCartManufacturing(payload);

        findItemInCart();
    };

    const findItemInCart = async () => {
        if (user) {
            await getItemsInCartManufacturing({ ssoId: user.ssoid }, current => {
                fillCartTable(current);
                const rmaCartIdsFromCart = current.data
                    .map((item: any) => item.id)
                    .filter((id: number | undefined): id is number => typeof id == 'number');
                setRmaCartIds(rmaCartIdsFromCart);
            });
        }
    };

    const fillCartTable = (current: any) => {
        if (!current.data.length) {
            setDetails([]);
            setData([]);
            return;
        }

        const newItems: any[] = [];
        const accessoriesItems: any[] = [];

        current.data.forEach((item: RmaItemsMf) => {
            if (!rmaState?.rmaItems?.some(e => e.id === item.id)) {
                setRmaState(old => ({
                    ...old,
                    rmaItems: [...(old?.rmaItems ?? []), item]
                }));
            }

            const volumeType = item?.rmaCartManufacturing?.volumeType;
            const volumeTypeMap: Record<number, string> = {
                1: 'NF (Integral)',
                2: 'Caixas',
                3: 'Paletes',
                4: 'Unidades'
            };

            const newItem: any = {
                Model: item.model,
                GBE: item?.rmaCartManufacturing?.gbe ?? '-',
                Id: item.id,
                SerialNumber: item?.rmaItemsEquipment?.serialNumber,
                SsoId: user?.ssoid,
                ProblemLocation: item?.rmaItemsEquipment?.problemLocation.name,
                TipoVolume: typeof volumeType === 'number' ? volumeTypeMap[volumeType] : '',
                NfHoneywell: item?.rmaCartManufacturing?.nfHoneywell,
                Quantity: item?.rmaCartManufacturing?.quantity ?? '-',
                Cell: (
                    <Icon
                        root="common"
                        name="delete"
                        size="medium"
                        loading={loadingDel}
                        onClick={() => {
                            openModal(item?.id);
                        }}
                    />
                )
            };

            if (item.rmaItemsEquipment) {
                newItem.Description =
                    item.rmaItemsEquipment.problemLocationId !== PROBLEMA_OUTRO
                        ? '-'
                        : item.rmaItemsEquipment.problemTypeDescription;
                newItems.push(newItem);
            }
        });
        setDetails(newItems);
        setData(accessoriesItems);

        setNewEquipment(current => {
            const { rmaItemsEquipment, rmaItemsAccessories, ...rest } = current;
            const newModel = tab === 0 ? new rmaItemsEquipmentModelMf() : new rmaItemsAccessoriesModelMf();
            return {
                ...rest,
                model: null,
                ...(tab === 0 ? { rmaItemsEquipment: newModel } : { rmaItemsAccessories: newModel })
            };
        });

        setNewManufacturing(current => {
            const { rmaCartManufacturing, ...rest } = current;
            return {
                ...rest,
                rmaCartManufacturing: new rmaCartManufacturingModelMf()
            };
        });
    };

    const deleteItemCart = async (id: number) => {
        setLoadingDel(true);
        try {
            let resp: { status: number; data: any; message?: any } = await itemCartDelete(id);
            if (resp.status !== 200) {
                const errorMessage = resp.message || 'Não foi possível remover o item. Tente novamente.';
                throw new Error(errorMessage);
            } else {
                const index = rmaState?.rmaItems!.findIndex(e => e.id == id);
                const updatedList = [...rmaState.rmaItems!];
                updatedList.splice(index, 1);
                findItemInCart();
                setRmaState(old => ({ ...old, rmaItems: updatedList }));
                setShowModal(false);
            }
        } catch (error: any) {
            setShowModal(false);
        } finally {
            setLoadingDel(false);
        }
    };

    const openModal = (item: any) => {
        setDeletedItem(item);
        setShowModal(true);
    };

    const postXLSX = async () => {
        setFullLoading(t('common:translation.Importing'));
        setUploadXLSX(false);

        if (arquivoXLSX != undefined && user?.ssoid) {
            let resp: { status: number; data: any; message?: any } = await uploadRmaExcel(arquivoXLSX, user.ssoid);

            const isRealSucess = resp.status == 200 && resp.message?.includes('Itens adicionados:');
            setUploadXLSXSuccess(isRealSucess);

            let msg: string = resp.message ?? t('translation.FileOpened');

            if (resp.status === 200) {
                msg = resp.message;


                if (Array.isArray(resp.data) && resp.data.length > 0) {
                    msg += `\n${t('translation.FailedLines')}: ${resp.data.join(', ')}`;
                }
            }

            setUploadXLSXResult(msg);
            if (isRealSucess)
                findItemInCart();
        }

        setFullLoading('');
        setArquivoXLSX(undefined);
    };

    const changeTab = (i: number) => {
        setNewEquipment(current => {
            if (i === 0) {
                const { rmaItemsAccessories, ...rest } = current;
                return { ...rest, model: null, rmaItemsEquipment: new rmaItemsEquipmentModelMf() };
            } else {
                const { rmaItemsEquipment, ...rest } = current;
                return { ...rest, model: null, rmaItemsAccessories: new rmaItemsAccessoriesModelMf() };
            }
        });

        setNewManufacturing(current => {
            const safeCurrent = current ?? new NewManufacturingMf();
            const { rmaCartManufacturing, ...rest } = safeCurrent;
            return {
                ...rest,
                rmaCartManufacturing: new rmaCartManufacturingModelMf()
            };
        });
    };

    const clearAllItems = async () => {
        if (!rmaState?.rmaItems?.length) return;

        setLoadingDel(true);

        const promises = rmaState.rmaItems.map(item => itemCartDelete(item.id));
        const responses = await Promise.all(promises);

        const hasError = responses.some(resp => resp.status !== 200);

        if (!hasError) {
            setDetails([]);
            setData([]);
            setRmaState(old => ({ ...old, rmaItems: [] }));
            setRmaCartIds([]);
        }

        setLoadingDel(false);
    };


    const debouncedFetchFilteredPns = useCallback(
        (pn: string) => {
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current);
            }
            searchDebounceRef.current = setTimeout(() => {
                fetchFilteredPns(pn);
            }, 500);
        },
        [fetchFilteredPns]
    );

    // Cleanup no unmount
    useEffect(() => {
        return () => {
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current);
            }
            searchRequestIdRef.current++;
        };
    }, []);



    const renderModal = () => {
        return (
            <>
                <Modal
                    closeIcon={true}
                    onClose={() => setUploadXLSX(false)}
                    open={uploadXLSX}
                    size="small"
                    style={{ width: '80%' }}
                >
                    <Modal.Header>{t('translation.UploadSpreadsheet')}</Modal.Header>
                    <Modal.Content style={{ maxWidth: '1000px' }}>
                        <div
                            style={{
                                display: 'flex',
                                gap: '12px',
                                marginBottom: '5px',
                                flexWrap: 'wrap',
                                justifyContent: 'center'
                            }}
                        >
                            <div style={{ flex: 1, minWidth: '220px' }}>
                                <Alert text={t('translation.UploadXLSXT1')} />
                            </div>
                            <div style={{ flex: 1, minWidth: '220px' }}>
                                <Alert text={t('translation.NotApplicable')} />
                            </div>
                        </div>

                        <div
                            className="no-padding blue-text"
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => downloadPublicFile('manufatura-template', 'TemplateHoneywell.xlsx')}
                        >
                            <LabelDescription title="TemplateHoneywell.xlsx" />
                        </div>
                        <FileDrop
                            style={{ marginTop: '20px' }}
                            acceptedTypes={['.xlsx']}
                            resetButtonText={t('common:actions.Clean')}
                            multiple={false}
                            buttonText={t('common:actions.BrowseFiles')}
                            label={t('common:translation.File').toUpperCase()}
                            placeholder={t('common:actions.Draganddropfileshere')}
                            onAccepted={(file: File[]) => setArquivoXLSX(file[0])}
                        ></FileDrop>
                    </Modal.Content>
                    <Modal.Footer>
                        <Button
                            type="secondary"
                            size="small"
                            content={t('common:actions.Cancel')}
                            onClick={() => setUploadXLSX(false)}
                        />
                        <Button type="primary" size="small" content="Ok" loading={loading} onClick={() => postXLSX()} />
                    </Modal.Footer>
                </Modal>
                <Modal
                    className="popup-theme-wrap"
                    onClose={() => setUploadXLSXResult('')}
                    open={uploadXLSXResult != ''}
                    size="small"
                >
                    <Modal.Header>{t('translation.UploadSpreadsheet')}</Modal.Header>
                    <Modal.Content>
                        <Notification hasIcon={true} severity={uploadXLSXSuccess ? 'success' : 'critical'}>
                            {uploadXLSXResult.split(/\r?\n/).map((line, index) => (
                                <React.Fragment key={index}>
                                    {line}
                                    <br />
                                </React.Fragment>
                            ))}
                        </Notification>
                    </Modal.Content>
                    <Modal.Footer>
                        <Button
                            type="primary"
                            size="small"
                            content="Ok"
                            loading={loading}
                            onClick={() => setUploadXLSXResult('')}
                        />
                    </Modal.Footer>
                </Modal>
                <Modal className="popup-theme-wrap" open={fullLoading != ''} size="small">
                    <Modal.Header></Modal.Header>
                    <Modal.Content>
                        <Loader overlayColor="#202020" text={fullLoading} inverted />
                    </Modal.Content>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            </>
        );
    };

    const getSerialFieldTexts = () => {
        const tipoVolume = newManufacturing.rmaCartManufacturing?.volumeType;

        if (tipoVolume === 2) {
            return {
                label: t('common:translation.BoxCode'),
                placeholder: t('common:translation.EnterBoxCode')
            };
        }

        if (tipoVolume === 3) {
            return {
                label: t('common:translation.PalletCode'),
                placeholder: t('common:translation.EnterPalletCode')
            };
        }

        return {
            label: t('common:translation.SerialNumber'),
            placeholder: t('common:translation.EnterSerialNumber')
        };
    };

    const isAddButtonDisabled = () => {
        const eq = newManufacturing?.rmaCartManufacturing;
        const ab = newEquipment?.rmaItemsEquipment;

        if (!eq || !ab) return true;

        const requiredFieldsFilled =
            eq.volumeType && eq.nfHoneywell?.toString().trim() !== '' && ab.problemLocationId && eq.identifiedTime;

        const needsDescription = ab.problemLocationId == PROBLEMA_OUTRO ? ab.problemTypeDescription : ab.problemLocationId;

        const needModelOrSerialnumber = eq.volumeType !== 1 ? newEquipment.model && ab.serialNumber : true;

        const needsQuantity = eq.volumeType !== 1 ? eq.quantity : true;

        return !requiredFieldsFilled || !needsDescription || !needModelOrSerialnumber || !needsQuantity;
    };

    const { label: serialLabel, placeholder: serialPlaceholder } = getSerialFieldTexts();

    return (
        <>

            <div>
                {renderModal()}
                <div className="container">
                    <span>
                        <Card>
                            <Card.Content>
                                <h1>
                                    <Icon root="common" name="device-add" size="large" /> {t('common:actions.Add')}
                                </h1>
                                <Alert text={t('translation.TextNotificationAcessory')} />
                                <div>
                                    <Tab
                                        defaultActiveIndex={0}
                                        className="tab-with-divider"
                                        onTabChange={(index: number) => {
                                            setTab(index);
                                            changeTab(index);
                                        }}
                                    >
                                        <Tab.Pane title={t('rma.order.Equipments')}>
                                            <div className="form4Columns">
                                                <Select
                                                    indicator="required"
                                                    label={t('rmamanufatura:translation.VolumeType')}
                                                    placeholder="Selecione"
                                                    value={newManufacturing.rmaCartManufacturing?.volumeType ?? ''}
                                                    options={volOptionMf}
                                                    onChange={(value: any) =>
                                                        setNewManufacturing({
                                                            ...newManufacturing,
                                                            rmaCartManufacturing: {
                                                                ...newManufacturing.rmaCartManufacturing,
                                                                volumeType: value
                                                            }
                                                        })
                                                    }
                                                />
                                                <Input
                                                    indicator="required"
                                                    placeholder={t('rmamanufatura:translation.NFHoneywell')}
                                                    label={t('rmamanufatura:translation.NFHoneywell')}
                                                    value={newManufacturing.rmaCartManufacturing?.nfHoneywell ?? ''}
                                                    onChange={(value: any) =>
                                                        setNewManufacturing({
                                                            ...newManufacturing,
                                                            rmaCartManufacturing: {
                                                                ...newManufacturing.rmaCartManufacturing,
                                                                nfHoneywell: value
                                                            }
                                                        })
                                                    }
                                                    disabled={details.length > 0}
                                                />
                                                <Select
                                                    indicator={"required"}
                                                    options={opcoesSelect ?? []}
                                                    label={t('rmamanufatura:translation.Model/PN')}
                                                    placeholder={t('common:placeholders.InputPartNumber')}
                                                    value={newEquipment.model ?? ''}
                                                    search={true}
                                                    loading={loadPartNumbers}
                                                    onSearch={(inputText: string) => {
                                                        debouncedFetchFilteredPns(inputText);
                                                    }}
                                                    onChange={(selectedCode: string) => {
                                                        const selectedItem = opcoesSelect?.find((item: { value: string; text: string; lob: string }) => item.value === selectedCode);
                                                        const selectedLob = selectedItem?.lob ?? '';
                                                        setLob(selectedLob);
                                                        setNewEquipment({ ...newEquipment, model: selectedCode, ssoId: user?.ssoid });
                                                    }}
                                                />
                                                <Input
                                                    indicator={"required"}
                                                    label={"GBE"}
                                                    placeholder={"GBE"}
                                                    disabled
                                                    value={newManufacturing.rmaCartManufacturing?.gbe ?? ''}
                                                    onChange={(value: any) =>
                                                        setNewManufacturing({
                                                            ...newManufacturing,
                                                            rmaCartManufacturing: {
                                                                ...newManufacturing.rmaCartManufacturing,
                                                                gbe: value
                                                            }
                                                        })
                                                    }
                                                />

                                            </div>
                                            <div className="form4Columns">
                                                <Input
                                                    indicator={
                                                        newManufacturing.rmaCartManufacturing?.volumeType !== 1
                                                            ? 'required'
                                                            : undefined
                                                    }
                                                    placeholder={t('rmamanufatura:translation.Quantity')}
                                                    label={t('rmamanufatura:translation.Quantity')}
                                                    disabled={newManufacturing.rmaCartManufacturing?.volumeType == 1 || newManufacturing.rmaCartManufacturing?.volumeType == 4}
                                                    value={newManufacturing.rmaCartManufacturing?.quantity ?? ''}
                                                    onChange={(value: any) =>
                                                        setNewManufacturing({
                                                            ...newManufacturing,
                                                            rmaCartManufacturing: {
                                                                ...newManufacturing.rmaCartManufacturing,
                                                                quantity: value
                                                            }
                                                        })
                                                    }
                                                />
                                                <Input
                                                    indicator={
                                                        newManufacturing.rmaCartManufacturing?.volumeType !== 1
                                                            ? 'required'
                                                            : undefined
                                                    }
                                                    label={serialLabel}
                                                    placeholder={serialPlaceholder}
                                                    disabled={newManufacturing.rmaCartManufacturing?.volumeType == 1}
                                                    value={newEquipment.rmaItemsEquipment?.serialNumber ?? ''}
                                                    onChange={(value: any) =>
                                                        setNewEquipment({
                                                            ...newEquipment,
                                                            rmaItemsEquipment: {
                                                                ...newEquipment.rmaItemsEquipment,
                                                                serialNumber: value
                                                            }
                                                        })
                                                    }
                                                />
                                                <Select
                                                    indicator={'required'}
                                                    className="SelectStyle"
                                                    label={t('manage_eos.translation.ProblemLocation')}
                                                    disabled={details.length > 0}
                                                    placeholder={t('manage_eos.translation.ProblemLocation')}
                                                    search={true}
                                                    value={newEquipment.rmaItemsEquipment?.problemLocationId}
                                                    options={buildSelect(problemLocationsAndTypes?.data)}
                                                    onChange={(value: any) => {
                                                        setNewEquipment({
                                                            ...newEquipment,
                                                            rmaItemsEquipment: {
                                                                ...newEquipment.rmaItemsEquipment,
                                                                problemLocationId: value
                                                            }
                                                        });
                                                    }}
                                                />
                                                <Input
                                                    indicator={
                                                        newEquipment.rmaItemsEquipment?.problemLocationId === PROBLEMA_OUTRO
                                                            ? 'required'
                                                            : undefined
                                                    }
                                                    placeholder={t('common:translation.ProblemDescription')}
                                                    label={t('common:translation.ProblemDescription')}
                                                    disabled={
                                                        newEquipment.rmaItemsEquipment?.problemLocationId !== PROBLEMA_OUTRO ||
                                                        details.length > 0
                                                    }
                                                    value={newEquipment.rmaItemsEquipment?.problemTypeDescription ?? ''}
                                                    onChange={(value: any) =>
                                                        setNewEquipment({
                                                            ...newEquipment,
                                                            rmaItemsEquipment: {
                                                                ...newEquipment.rmaItemsEquipment,
                                                                problemTypeDescription: value
                                                            }
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="form4Columns">
                                                <Select
                                                    indicator="required"
                                                    label={t('rmamanufatura:translation.IdentifiedTime')}
                                                    placeholder={t('rmamanufatura:translation.IdentifiedTime')}
                                                    value={newManufacturing.rmaCartManufacturing?.identifiedTime ?? ''}
                                                    options={timeMf}
                                                    disabled={details.length > 0}
                                                    onChange={(value: any) =>
                                                        setNewManufacturing({
                                                            ...newManufacturing,
                                                            rmaCartManufacturing: {
                                                                ...newManufacturing.rmaCartManufacturing,
                                                                identifiedTime: value
                                                            }
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="buttonsSearch">
                                                <Button
                                                    type="primary"
                                                    icon="slidercontrols-plus"
                                                    content={t('common:actions.XLSXUpload')}
                                                    iconPosition="right"
                                                    loading={loading}
                                                    onClick={() => setUploadXLSX(true)}
                                                />

                                                <Button
                                                    type="primary"
                                                    icon="slidercontrols-plus"
                                                    content={t('common:actions.Add')}
                                                    iconPosition="right"
                                                    loading={loading}
                                                    disabled={isAddButtonDisabled()}
                                                    onClick={() => addEquipment()}
                                                />
                                            </div>
                                        </Tab.Pane>
                                    </Tab>
                                </div>
                            </Card.Content>
                        </Card>
                    </span>
                </div>
                <div className="container">
                    <Card>
                        <Card.Content>
                            <Modal
                                className="popup-theme-wrap"
                                onClose={() => setShowModal(false)}
                                open={showModal}
                                size="small"
                            >
                                <Modal.Content>{t('rma.order.DeleteItem')}</Modal.Content>
                                <Modal.Footer>
                                    <Button
                                        type="secondary"
                                        size="small"
                                        content="Cancel"
                                        onClick={() => setShowModal(false)}
                                    />
                                    <Button
                                        type="primary"
                                        size="small"
                                        content="Delete"
                                        loading={loadingDel}
                                        onClick={() => deleteItemCart(deletedItem)}
                                    />
                                </Modal.Footer>
                            </Modal>
                            <h1>
                                <Icon root="common" name="device-add" size="large" /> {t('translation.ServiceBag')}
                            </h1>
                            <br />
                            <div className="div-datatable2" style={{ marginBottom: '40px' }}>
                                <div style={{ marginRight: '15px' }}>
                                    <h3>
                                        {t('common:translation.Equipments')} ({details.length})
                                    </h3>
                                    <DataTable
                                        data={details}
                                        rows={500}
                                        scrollable={true}
                                        virtualScroll={true}
                                        scrollHeight="800px"
                                    >
                                        <DataTable.Column field="TipoVolume" header={t('rmamanufatura:translation.VolumeType')} />
                                        <DataTable.Column field="NfHoneywell" header={t('rmamanufatura:translation.NFHoneywell')} />
                                        <DataTable.Column field="Model" header={t('Model')} sortable={true} />
                                        <DataTable.Column field="GBE" header={'GBE'} sortable={true} />
                                        <DataTable.Column field="Quantity" header={t('rmamanufatura:translation.Quantity')} />
                                        <DataTable.Column
                                            field="ProblemLocation"
                                            header={t('common:translation.Problem')}
                                        ></DataTable.Column>
                                        <DataTable.Column
                                            field="Description"
                                            header={t('common:translation.Description')}
                                            sortable={true}
                                        />
                                        <DataTable.Column
                                            field="SerialNumber"
                                            header={t('rmamanufatura:translation.SerialNumber')}
                                            sortable={true}
                                        />
                                        <DataTable.Column field="Cell" header={t('common:actions.Delete')} />
                                    </DataTable>
                                </div>
                            </div>
                            <div className="buttonsSearch">
                                <Button
                                    type="secondary"
                                    content={t('common:actions.ClearAll')}
                                    loading={loadingDel}
                                    onClick={clearAllItems}
                                />
                            </div>
                        </Card.Content>
                    </Card>
                </div>
                <div className="container">
                    <ImagesManufacturing rmaCartIds={rmaCartIds} />
                </div>
                <div className="container">
                    <div className="buttonsSearch">
                        <Button
                            type="primary"
                            icon="slidercontrols-plus"
                            content={t('common:translation.Next')}
                            loading={loading}
                            iconPosition="right"
                            disabled={!details.length && !data.length}
                            onClick={() => nextPage()}
                        />
                    </div>
                </div>
            </div>

        </>
    );
}
export default NewRma;
